<template>
  <div class="container" dir="ltr">
    <div class="title-block">
      {{ $t('TERMS OF USE') }}
    </div>
    <div
      class="flex justify-between"
      style="scroll-behavior: smooth;"
    >
      <div class="main-info">
        <div class="paragraph-block">
          <ol class="main-ol">
            <li
              ref="general"
              class="paragraph-title"
            >
              {{ $t('GENERAL') }}
              <ol class="paragraph-element">
                <li>{{ $t('These Terms of Use establishes the conditions that govern the access to, navigation and the use of the website https://dreamflat.design (referred to as the “Website”) and its functionalities, ustomer support, interactive areas and services (together referred to as the “Services”), and software, as well as any applications, including mobile applications, scripts, and instruction sets (together referred to as the “Software”). The Website, the Software, and the Services are collectively referred to as the &quot;Platform&quot;. We urge you (also referred to as the &quot;User&quot;) to read these Terms of Use as well as our Privacy and Cookie Policy (referred to as the “Data Protection Policies”) carefully before using this Platform. When you use the Platform, you are aware that you are bound by these Terms of Use and our Data Protection Policies. If you don’t agree with the Terms of Use and with the Data Protection Policies, you mustn’t use the Platform.') }}</li>
                <li v-if="isDflat">
                  {{ $t('The Platform and its services are operated by VR INVEST LLC (referred to as “DreamFlat” or “we”) with registered at UAE, with e-mail address info@dreamflat.design, registered in the Register of Companies of Dubai, with number 45001026.') }}
                </li>
                <li v-if="!isDflat">
                  {{ $t('The Platform and its services are operated by DreamFlat FZ-LLC (referred to as “DreamFlat” or “we”) with registered at UAE, with e-mail address info@dreamflat.design, registered in the Register of Companies of Dubai, with number 45001026.') }}
                </li>
                <li>
                  {{ $t('Providing access to the Platform and its services, we proceed from the assumption that you:') }}
                  <ol>
                    <li>
                      acting on your own behalf represent the legitimate interests of a company (Business
                      User), or are acting on your own behalf and in your own interest (Individual User) and
                      have all the necessary authority to register on and use this Platform;
                    </li>
                    <li>
                      provide true information about yourself to the extent necessary for use of the Platform;
                    </li>
                    <li>
                      are responsible for the actions you take on the Platform;
                    </li>
                    <li>
                      are aware of and accept the Data Protection Policies;
                    </li>
                    <li>
                      are aware of and accept these Terms of Use.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li
              ref="status-of-the-terms-of-use"
              class="paragraph-title"
            >
              {{ $t('STATUS OF THE TERMS OF USE') }}
              <ol class="paragraph-element">
                <li>
                  These Terms of Use are the legally binding agreement between you and DreamFlat
                  whereby DreamFlat provides you with services of the Platform. These Terms of Use
                  apply to the entire business relationship between you and DreamFlat and regulate the
                  mutual rights and obligations.
                </li>
                <li>
                  You should be fully aware of these Terms of Use before registering at the Platform.
                  Your registration at the Platform means your full and unconditional acceptance of these
                  Terms of Use.
                </li>
                <li>
                  Use of the Software, in addition to these Terms of Use, is also governed by the License
                  Agreement, which is part of these Terms of Use. If there is any conflict between the
                  Terms of Use and the License Agreement, the License Agreement applies to the
                  Software license relations.
                </li>
              </ol>
            </li>
            <li
              ref="registration-at-the-platform"
              class="paragraph-title"
            >
              {{ $t('REGISTRATION AT THE PLATFORM') }}
              <ol class="paragraph-element">
                <li>
                  To access the Platform and a limited set of Services and Software, registration is not
                  required. To use a broader, more comprehensive set of Services and Software, you
                  need to register on the Platform. As an Individual User or a Business User, you may
                  create an account using an email address. In such cases, the you should provide the
                  requested information and follow the established registration process in order to access
                  the Services and Software.
                </li>
                <li>
                  By registering, you accept and approve the need to receive some technical information
                  from us in connection with the use of the Platform by e-mail and text message.
                </li>
                <li>
                  The login and password you have chosen are the necessary and sufficient information
                  for your access to the Platform. You are not allowed to transfer your login and
                  password to third parties. You are solely responsible for the confidentiality of your login
                  and password by choosing how they are kept. Using your hardware and software you
                  may permit storage of the login and password (through cookies) for subsequent
                  automatic authorization on the Platform.
                </li>
                <li>
                  Unless you can prove otherwise, any action taken using your login and password is
                  deemed to have been taken by you. In case of unauthorized access to your login and
                  password you should notify us immediately via helpdesk of the Platform.
                </li>
              </ol>
            </li>
            <li
              ref="use-of-platform"
              class="paragraph-title"
            >
              {{ $t('USE OF PLATFORM') }}
              <ol class="paragraph-element">
                <li>
                  <b>License</b><br>
                  <ol>
                    <li>
                      Subject to your compliance with the Terms of Use and applicable law, you may access
                      and use the Software that we make available, and that you license from us. Use of the
                      Software is governed by the License Agreement. When installing the Software, you
                      should aware and accept the terms of the License Agreement.
                    </li>
                  </ol>
                </li>
                <li>
                  <b>Advanced Services</b><br>
                  <ol>
                    <li>
                      Normally the Software and Services can be used free of charge (referred to as
                      the “Start Services”). Certain optional services that offer exclusive features and
                      enhanced functionality, such as “Premium”, “Designer+” and “Enterprise” (collectively
                      referred to as the “Advanced Services”), may be available for purchase. You can find
                      the terms and conditions of each Advanced Services package on the Website in the
                      &quot;Tariffs&quot; section. By purchasing Advanced Services, you agree to allow recurring
                      monthly payments to be made by DreamFlat using the payment method of your choice
                      until the subscription is cancelled by you or by DreamFlat.
                    </li>
                    <li>
                      Users in some regions may be required to pay local taxes, which will be
                      calculated and added to the total purchase price. Payment providers may apply their
                      own fees and conversion rates to payments in different currencies. This is not within
                      our control.
                    </li>
                    <li>
                      You can change or cancel Advanced Services any time. To change or cancel
                      your subscription, follow the instructions in your account on the Website. In case of
                      cancellation, your subscription will remain active from the time you cancel until the end
                      of your current billing period, and you will not receive a refund or credit for any
                      remaining days in your current billing period. At the end of your subscription you will
                      lose access to all features associated with Advanced Services.
                    </li>
                  </ol>
                </li>
                <li>
                  <b>User’s Content</b><br>
                  <ol>
                    <li>
                      When using the Services or Software, whether the Start Services or Advanced
                      Services, you may upload and import into or create with the Services or Software any
                      information or materials, such as audio files, video files, text or images (referred to as
                      the &quot;User’s Content&quot; or “your Content”). You must not upload your Content that is
                      prohibited by applicable law. We reserve the right to remove your Content or restrict
                      access to your Content and the Platform if any of your Content is found to be in breach
                      of these Terms.
                    </li>
                    <li>
                      By uploading your Content to the Platform, you agree that you have: (i) all
                      necessary licenses and permissions to use and Share (as applicable) your Content;
                      and (ii) the rights necessary to grant the licenses specified herein.
                    </li>
                    <li>
                      Solely for the purposes of operating or improving the Platform, when you upload
                      your Content to the Platform, you grant us a nonexclusive, worldwide, royalty-free,
                      sublicensable, and transferrable license to use the Content.
                    </li>
                    <li>
                      The Platform may provide features that allow you to share or make your Content
                      available to others. You can share your Content by submitting a special form through
                      your use of the Services and Software or by sharing on social media sites. Other users
                      may use, copy, modify or re-share your Content in various ways. Please think carefully
                      about what you choose to share or make public, as you are responsible for the Content
                      you share.
                    </li>
                    <li>
                      If you post your Content for public sharing through the Platform, we are not
                      responsible for: (i) any loss, damage or corruption of your Content; (ii) removal of your
                      Content by anyone other than DreamFlat; or (iii) inclusion of your Content by third
                      parties on other websites or in other media.
                    </li>
                  </ol>
                </li>
                <li>
                  <b>When using the Platform you are not allowed to:</b><br>
                  <ol>
                    <li>
                      take actions aimed at disrupting the normal operation of the Website, the
                      Services and the Software;
                    </li>
                    <li>violate applicable law;</li>
                    <li>
                      load, storing, publishing, distributing, making available or otherwise using
                      viruses, trojans, worms, logic bombs or any other software or technologically
                      damaging or harmful material and other malicious software;
                    </li>
                    <li>
                      reproduce, duplicate, copy, sell, deal in and resell the access to the use of the
                      Platform, i.e. Advances Services, for any purpose without our direct consent;
                    </li>
                    <li>
                      use the Services or the Software without a license or agreement with DreamFlat
                      or in breach of such agreement;
                    </li>
                    <li>
                      copy, modify, host, stream, sublicense, or resell the Software;
                    </li>
                    <li>
                      authorize or permit others to use the Platform using your account information;
                    </li>
                    <li>
                      use the Platform to create any type of database or dataset;
                    </li>
                    <li>
                      offer, use, or authorize others to use the Services or Software in a computer
                      services business, on a membership or subscription basis, on a service bureau
                      basis, on a time-sharing basis, as part of a hosted service, or on behalf of any
                      third party;
                    </li>
                    <li>
                      obtain or attempt to obtain access to the Services or the Software by any
                      means other than the interface that we provide or permit;
                    </li>
                    <li>
                      impersonate any person or entity, or falsely state or otherwise misrepresent
                      your affiliation with a person or entity;
                    </li>
                    <li>
                      circumvent any access or use restrictions imposed to prevent certain uses of
                      the Platform;
                    </li>
                    <li>
                      share content or otherwise engage in conduct that violates someone else&#39;s
                      intellectual rights, unfair competition, right of privacy, right of publicity and any
                      other proprietary rights;
                    </li>
                    <li>
                      share any content that is unlawful, harmful, threatening, obscene, violent,
                      abusive, wrongful, defamatory, vulgar, profane, lewd, invasive of the privacy of
                      others, hateful or otherwise objectionable;
                    </li>
                    <li>
                      share any content that sexualizes minors or is intended to promote
                      inappropriate interactions with minors, other DreamFlat users, or the public;
                    </li>
                    <li>
                      use any data mining or similar data collection and extraction techniques in
                      connection with the Services or Software, including scraping data for machine
                      learning or other purposes
                    </li>
                    <li>
                      attempt to disable, impair, or destroy the Platform;
                    </li>
                    <li>
                      advertise any products or services on the Platform, except with our prior written
                      consent.
                    </li>
                  </ol>
                </li>
                <li>
                  You undertake not to attempt to make unauthorized access to the Platform, the server on which
                  the Platform is hosted or any server, computer or database related to the Platform, as well as
                  not to attack the Platform through any attack of denial of service (DoS) or an attack of
                  distributed denial of service (DDoS).
                </li>
                <li>
                  In the event of failure to comply with clauses 4.4 and 4.5 above, authorization to use the
                  Platform shall be suspended immediately. Failure to comply with these clauses will be
                  considered a violation under applicable law. We will report any non-compliance with the
                  applicable law to the appropriate authorities and will co-operate with them to establish the
                  identity of the infringer.
                </li>
              </ol>
            </li>
            <li
              ref="intellectual-property"
              class="paragraph-title"
            >
              {{ $t('INTELLECTUAL PROPERTY') }}
              <ol class="paragraph-element">
                <li>
                  You recognize and agree that all copyrights, registered trademarks, trade dresses,
                  patents, trade secrets and other intellectual property rights on all materials or contents
                  placed on the Platform (referred to as the “Content”) belong to DreamFlat at all times
                  or to those who grant to DreamFlat license for their use.
                </li>
                <li>
                  With regard to all rights to Content (e.g. property rights, industrial property rights,
                  copyright), no license or other right is granted to anyone, except as set forth herein and
                  in the License Agreement. Reproducing, copying, collecting, systemizing, storing and
                  transferring the Content whether for commercial and/or non-commercial purpose and/or using the Content in whole or its part regardless of the way of use is not allowed
                  without our consent. The use of marks (e.g. trademarks, logos), whether with the ® or
                  ™ symbol, is expressly prohibited.
                </li>
              </ol>
            </li>
            <li
              ref="indemnification"
              class="paragraph-title"
            >
              {{ $t('INDEMNIFICATION') }}
              <ol class="paragraph-element">
                <li>
                  You release us and our subsidiaries, affiliates, officers, agents, employees, partners and
                  licensors from any claim, demand, loss or damage, including reasonable attorneys&#39; fees, arising
                  out of or in connection with your Content, your use of the Platform or your violation of the
                  Terms. We have the right to oversee the defense of any claim, action or case subject to
                  indemnification on your part with an attorney of our choosing. You will cooperate fully with us in
                  the defense of any such claim, action or suit.
                </li>
              </ol>
            </li>
            <li
              ref="disclaimer"
              class="paragraph-title"
            >
              {{ $t('DISCLAIMER') }}
              <ol class="paragraph-element">
                <li>
                  The Software and the Services are provided on &quot;AS IS” and “AS AVAILABLE” basis. To the
                  maximum extent permitted by law, we disclaim all warranties, express or implied, including
                  implied warranties of non-infringement, merchantability and fitness for a particular purpose. We
                  make no commitment whatsoever as to the content of the Services. We also disclaim any
                  warranty that (i) the Platform will meet your requirements or will be consistently available,
                  uninterrupted, timely, secure or error-free; (ii) the results obtained from the use of the Platform
                  will be effective, accurate or reliable; (iii) the quality of the Software or Services will meet your
                  expectations; or (iv) any errors or defects in the Platform will be corrected.
                </li>
                <li>
                  We reserve the right, at any time and without prior notice, to terminate access to the Platform,
                  as well as the provision of any or all of the service presented thereon, for security, control,
                  technical or maintenance reasons, or due to a power failure.
                </li>
                <li>
                  We specifically disclaim all liability for any actions resulting from your use of the Platform. You
                  may use and access the Platform at your own discretion and risk, and you will be solely
                  responsible for any damage to your computer system or loss of data resulting from your use of
                  and access to the Platform
                </li>
                <li>
                  We are not responsible for any interruptions in the operation of the Platform or other
                  inconveniences caused by reasons beyond our control, and / or due to fraudulent or negligent
                  actions of Users and / or caused by force majeure.
                </li>
                <li>
                  We are not responsible for the use by Users of the Platform or its services in a way that violates
                  any national or international regulations, intellectual or industrial property rights or any other
                  rights of third parties. We are also not responsible for any security errors that may be caused by
                  the use of outdated versions of browsers, or for the consequences that may arise as a result of
                  improper use of the browser, be it misconfiguration, the presence of a computer virus or any
                  other reason not related to DreamFlat.
                </li>
                <li>
                  We shall not be held liable for any damage or harm resulting from a denial of service attack,
                  virus or any other software or technologically damaging or harmful material that may affect your
                  computer, IT equipment, data or materials as a result of using the Platform.
                </li>
                <li>
                  We assume no liability and warranty for the contents of all websites linked to the Platform. This
                  declaration applies to all external links and all further links on the Platform. We are also not
                  liable for the constant availability or full functionality of links to websites or URLs of other
                  operators. If you decide to leave the Platform to visit third party websites or to use or install third
                  party software, you do so at your own risk and from that point onwards these Terms of Use no
                  longer apply to you.
                </li>
                <li>
                  Under no circumstances we shall be liable for any loss or damage of any kind (including
                  consequential or indirect damage or loss of profit) caused by or in connection with actions of
                  third parties or external resources that pretend to be DreamFlat but are not, including third-party
                  websites copying Content, clone websites.
                </li>
                <li>
                  DreamFlat is entitled to place advertisements or other marketing-related content at any time at
                  the Platform.
                </li>
                <li>
                  We regularly check and modify the information on the Platform. Nevertheless, data and
                  information may already have lost their validity. To the extent permitted by effective legislation,
                  liability and warranty for the accuracy and completeness of the published information and data
                  is therefore excluded.
                </li>
              </ol>
            </li>
            <li
              ref="closing-provisions"
              class="paragraph-title"
            >
              {{ $t('CLOSING PROVISIONS') }}
              <ol class="paragraph-element">
                <li>
                  These Terms of Use constitute the entire agreement between you and us as regards
                  the purpose of the same, superseding any previous contracts, agreements or promises
                  made between you and us orally or in writing.
                </li>
                <li>
                  The use of the Platform shall be governed by the laws of the Emirate of Dubai and the
                  Federal laws of the UAE applicable thereto. In case any disputes or differences arise in
                  connection with the fulfillment of these Terms of Use or are related to the use of the
                  Platform, the User and DreamFlat will make every effort to resolve these by
                  negotiations. Those disputes which are not resolved by negotiations shall be subject to
                  the non-exclusive jurisdiction of the Dubai courts.
                </li>
                <li>
                  These Terms of Use become binding upon you from the time of your accession and are
                  valid during an indefinite period.
                </li>
                <li>
                  We may update these Terms of Use at any time to reflect legal, technical, or business
                  changes. You are subject to the Terms of Use and Data Protection Policies in effect at
                  the time you use the Platform. When we update these Terms of Use, we will take
                  reasonable steps to inform you of the importance of the changes. You will find the &quot;last
                  updated&quot; date at the end of these Terms of Use.
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
      <div class="legal-table-contents">
        <ol>
          <li><a @click="scrollToAnchorPoint('general')">{{ $t('GENERAL') }}</a></li>
          <li><a @click="scrollToAnchorPoint('status-of-the-terms-of-use')">{{ $t('STATUS OF THE TERMS OF USE') }}</a></li>
          <li><a @click="scrollToAnchorPoint('registration-at-the-platform')">{{ $t('REGISTRATION AT THE PLATFORM') }}</a></li>
          <li><a @click="scrollToAnchorPoint('use-of-platform')">{{ $t('USE OF PLATFORM') }}</a></li>
          <li><a @click="scrollToAnchorPoint('intellectual-property')">{{ $t('INTELLECTUAL PROPERTY') }}</a></li>
          <li><a @click="scrollToAnchorPoint('indemnification')">{{ $t('INDEMNIFICATION') }}</a></li>
          <li><a @click="scrollToAnchorPoint('disclaimer')">{{ $t('DISCLAIMER') }}</a></li>
          <li><a @click="scrollToAnchorPoint('closing-provisions')">{{ $t('CLOSING PROVISIONS') }}</a></li>
        </ol>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { useI18n } from 'vue-i18n'
import { useHead, useRuntimeConfig } from '#imports'

export default {
  setup () {
    const { t } = useI18n()
    const runtimeConfig = useRuntimeConfig()
    const isDflat = runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru')
    useHead({
      title: `${t(runtimeConfig.public.vueAppTitle)} - ${t('termOfUse')}`,
      meta: [
        {
          name: 'description', content: `${t('termMetaDesc')}`,
        },
      ],
    })
    useSeoMeta({
      ogTitle: `${t(runtimeConfig.public.vueAppTitle)} - ${t('termsOfUse')}`,
      description: `${t('termMetaDesc')}`,
      ogDescription: `${t('termMetaDesc')}`,
      ogImage: 'https://dreamflat.design/prev.webp',
    })
    return {
      isDflat,
    }
  },
  methods: {
    scrollToAnchorPoint (refName:string) {
      const el = this.$refs[refName] as HTMLLIElement
      el.scrollIntoView({ behavior: 'smooth' })
    },
  },
}

</script>
<style lang="scss">
.steps-link:after{
  content: '';
}
.title-block{
  font-size: 36px;
  font-weight: 700;
  margin: 30px 0 60px 0;
  color: #3D424A;
  line-height: 120%;
  letter-spacing: 0.03em;
}
.main-info{
  width: 650px;
  .paragraph-block{
    color: #3D424A;
    ol {
      margin:0 0 1.5em;
      padding:0;
    }
    .main-ol{
      counter-reset:item;
    }
    ol>li {
      padding:0 0 0 1.5em;
      text-indent:-1.5em;
      list-style-type:none;
    }
    ol>li:before {
      display:inline-block;
      width:1.5em;
      padding-right:0.5em;
      font-weight:bold;
      text-align:right;
    }
    .main-ol>li{
      counter-increment:item;
    }
    .main-ol>li:before{
      content:counter(item) ".";
    }
    .main-ol>li ol>li{
      counter-increment:item-t;
    }
    .main-ol>li ol>li:before {
      content:counter(item) "." counter(item-t);
    }

    .main-ol>li ol>li ol>li{
      counter-increment:item-three;
      padding:0 0 0 3.1em;
      text-indent:-1.5em;
      margin: 16px 0;
    }

    .main-ol>li ol>li ol>li:before {
      display:inline-block;
      width:1.5em;
      padding-right:0.5em;
      font-weight:bold;
      text-align:right;
      content:counter(item) "." counter(item-t) "." counter(item-three);
    }

    a{
      color: $primary;
      text-decoration: none;
    }
    .paragraph-title{
      font-size: 24px;
      font-weight: 700;
      .paragraph-element>*{
        font-size: 16px;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0.03em;
        margin: 16px 0;
      }
    }
  }
}
.legal-table-contents{
  width: 265px;
  ol{
    color: #839AAF;
    padding: 0;
    margin:0 0 1.1em;
    position: sticky;
    top: 50px;
    li{
      list-style-position: inside;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      margin-bottom: 8px;
      padding:0 0 0 1.1em;
      text-indent: -1.1em;
      cursor: pointer;
    }
    a{
      text-decoration: none;
      color: #839AAF;
    }
    a:active{
      color: #64686E;
    }
  }

}
@media (max-width: 1024px) {
  .main-info{
    width: 100%;
  }
  .legal-table-contents{
    width: 100%;
  }
  .title-block {
    margin-top: 32px;
  }
}
@media (max-width: 700px) {
  .title-block {
    font-size: 24px;
    line-height: 32px;
    margin: 32px 0 24px 0;
  }
  .legal-info-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .main-info {
      width: 100%;
      .paragraph-block {
        .main-ol {
          .paragraph-title {
            font-size: 18px;
          }
          .paragraph-element {
            li {
              font-size: 15px;
              line-height: 140%;
            }
          }
        }
      }
    }
  }
  .legal-table-contents {
    display: none;
  }
}
</style>
